var Marionette = require('backbone.marionette');

var Session = require('../../models/session-model');
var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var permissionsChannel = Radio.channel('session');
var actionsChannel = Radio.channel('actions');

var SetInitialViewModalView = require("../persons/set-initial-view");

var Header = Marionette.View.extend({
    template: require('../../templates/layout/header.html'),

    regions: {
        setInitialViewModal: '#initial-view-modal'
    },

    model: new Session(),
    activeMenu: 'organizations',
    modelEvents: {
        'change': 'render'
    },

    events: {
        'click #logout': 'performLogout',
        'click #set-initial-for-me': 'setCurrentViewAsInitialForMe',
        'click #set-initial': 'setCurrentViewAsInitial'
    },

    templateContext: function () {
        var that = this;
        return {
            isActiveMenu: that.isActiveMenu,
            menuItems: that.options.menuItems,
            isAdmin: that.body.byAdmin()
        }
    },

    initialize: function (options) {
        this.menuItems = options.menuItems;
        _.bindAll(this, 'onSessionChanged', 'onMenuChanged', 'performLogout', 'isActiveMenu', 'getPermissions', 'getUserId', 'clearAndToMainPage');
        permissionsChannel.reply('get:permissions', this.getPermissions);
        permissionsChannel.reply('get:userId', this.getUserId);
        this.body = options.body;
    },

    getPermissions: function () {
        var userId = this.model.get('person').login;
        var userSystemRoles = this.model.get('systemRoles');
        var userPermissions = this.model.get('permissions');
        return {
            userId: userId,
            userSystemRoles: userSystemRoles,
            userPermissions: userPermissions,
            isMd: this.model.get('person').isMd,
            isPatient: this.model.get('person').isPatient
        };
    },

    getUserId: function () {
        return this.model.get('person').login;
    },


    isActiveMenu: function (menuItem) {
        return (this.activeMenu.toLowerCase() == menuItem.toLowerCase()) ? 'active' : '';
    },

    onSessionChanged: function (session) {
        this.model.set(session.toJSON());
    },

    onMenuChanged: function (menuItem) {
        this.activeMenu = menuItem;
        this.options.menuItems.forEach(function (menuItem) {
            if (this.activeMenu.toLowerCase() == menuItem.title.toLowerCase()) {
                menuItem.activeClass = 'active';
            } else {
                menuItem.activeClass = '';
            }
        }, this);
        this.render();
    },


    performLogout: function () {
        var that = this;
        $.ajax({
            type: "DELETE",
            url: '/api/login/session',
            statusCode: {
                200: function () {
                    that.clearAndToMainPage();
                }
            }
        });
    },

    setCurrentViewAsInitialForMe: function () {
        var url = window.location.hash;
        $.ajax({
            type: "POST",
            url: '/api/person/initial-url',
            contentType: 'text/plain',
            data: url,
            statusCode: {
                200: function () {
                    $.notify({
                        message: 'Initial View was set successfully'
                    }, {
                        type: 'success',
                        z_index: 2000
                    });
                }
            },
            error: function (e) {
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    setCurrentViewAsInitial: function () {
        console.log("setCurrentViewAsInitial");
        var url = window.location.hash;
        console.log(url);

        this.setInitialViewModalView = new SetInitialViewModalView();
        this.showChildView('setInitialViewModal', this.setInitialViewModalView);
        this.setInitialViewModalView.show(url);
    },

    clearAndToMainPage: function () {
        var that = this;
        var redirectUrl = '/login';
        if (Backbone.history.fragment != '' && Backbone.history.fragment != '/' && Backbone.history.fragment != 'login') {
            redirectUrl = redirectUrl + '?retpath=' +
                encodeURIComponent(Backbone.history.fragment);
        }
        that.options.menuItems.forEach(function (menuItem) {
            menuItem.activeClass = '';
        }, this);
        that.options.menuItems = _.map(that.options.defaultMenuItems, _.clone);
        that.model.clear();
        that.triggerMethod('invalidate:current:session:id');
        Backbone.history.navigate(redirectUrl, {trigger: true});
    }

});


module.exports = Header;


//////////////////
// WEBPACK FOOTER
// ./app/views/layout/header.js
// module id = 186
// module chunks = 0